import moment from '@/node_modules/moment/moment'

export const manualCash = (state) => {
  return state.manualCash.data || []
}
export const manualCashLoading = (state) => {
  return state.manualCash.loading
}
export const manualCashLastUpdate = (state) => {
  return state.manualCash.lastUpdate
}
export const revenueByArea = (state) => {
  return state.revenueByArea.data || []
}
export const revenueByAreaLoading = (state) => {
  return state.revenueByArea.loading
}
export const revenueByAreaLastUpdate = (state) => {
  return state.revenueByArea.lastUpdate
}

export const revenueByProduct = (state) => {
  return state.revenueByProduct.data || []
}
export const revenueByProductLoading = (state) => {
  return state.revenueByProduct.loading
}
export const revenueByProductLastUpdate = (state) => {
  return state.revenueByProduct.lastUpdate
}

export const professional = (state) => {
  return state.professional.data || []
}
export const professionalLoading = (state) => {
  return state.professional.loading
}
export const professionalLastUpdate = (state) => {
  return state.professional.lastUpdate
}

export const professionalKpis = (state) => {
  return state.professionalKpis.data || []
}
export const professionalKpisLoading = (state) => {
  return state.professionalKpis.loading
}
export const professionalKpisLastUpdate = (state) => {
  return state.professionalKpis.lastUpdate
}

export const dfc = (state) => {
  return state.dfc.data || []
}
export const dfcLoading = (state) => {
  return state.dfc.loading
}
export const dfcLastUpdate = (state) => {
  return state.dfc.lastUpdate
}

export const revenueAreas = (state) => {
  return state.revenueAreas.data || []
}
export const revenueAreasLoading = (state) => {
  return state.revenueAreas.loading
}
export const revenueAreasLastUpdate = (state) => {
  return state.revenueAreas.lastUpdate
}

export const filials = (state) => {
  return state.filials.data || []
}
export const filialsLoading = (state) => {
  return state.filials.loading
}
export const filialsLastUpdate = (state) => {
  return state.filials.lastUpdate
}

export const professionalDre = (state) => {
  return state.professionalDre.data || []
}
export const professionalDreLoading = (state) => {
  return state.professionalDre.loading
}
export const professionalDreLastUpdate = (state) => {
  return state.professionalDre.lastUpdate
}

export const balance = (state) => {
  return state.balance.data || []
}
export const balanceLoading = (state) => {
  return state.balance.loading
}
export const balanceLastUpdate = (state) => {
  return state.balance.lastUpdate
}

export const team = (state) => {
  return state.team.data || []
}
export const teamLoading = (state) => {
  return state.team.loading
}
export const teamLastUpdate = (state) => {
  return state.team.lastUpdate
}

export const lastUpdateReference = (state) => {
  return state.lastUpdateReference.data || []
}
export const lastUpdateReferenceLoading = (state) => {
  return state.lastUpdateReference.loading
}
export const lastUpdateReferenceLastUpdate = (state) => {
  return state.lastUpdateReference.lastUpdate
}

export const startDateUpdateReference = (state) => {
  const date = state.lastUpdateReference.data.data_referencia
  const startDateDefault = state.lastUpdateReference.data.default_begin_date

  if (startDateDefault) {
    return moment(startDateDefault, 'DD/MM/YYYY')
      .endOf('month')
      .format('DD/MM/YYYY')
  }

  if (date) {
    const momentDate = moment(date, 'DD/MM/YYYY')
    const diff = momentDate.diff(moment(), 'months', true)

    if (diff > -2) {
      return momentDate.add(-11, 'months').endOf('month').format('DD/MM/YYYY')
    }
  }

  return moment().add(-13, 'months').endOf('month').format('DD/MM/YYYY')
}

export const endDateUpdateReference = (state) => {
  const date = state.lastUpdateReference.data.data_referencia

  if (date) {
    const momentDate = moment(date, 'DD/MM/YYYY')
    const diff = momentDate.diff(moment(), 'months', true)

    if (diff > -2) {
      return momentDate.endOf('month').format('DD/MM/YYYY')
    }
  }

  return moment().add(-2, 'months').endOf('month').format('DD/MM/YYYY')
}
export const comparative = (state) => {
  return state.comparative.data || []
}
export const comparativeLoading = (state) => {
  return state.comparative.loading
}
export const comparativeLastUpdate = (state) => {
  return state.comparative.lastUpdate
}

export const filters = (state) => {
  return state.filters.data || {}
}
export const comissionBpo = (state) => {
  return state.comissionBpo.data || []
}
export const comissionBpoLoading = (state) => {
  return state.comissionBpo.loading
}
export const comissionBpoLastUpdate = (state) => {
  return state.comissionBpo.lastUpdate
}

export const dreVersion = (state) => {
  return state.dreVersion.data || []
}
export const dreVersionLoading = (state) => {
  return state.dreVersion.loading
}
export const dreVersionLastUpdate = (state) => {
  return state.dreVersion.lastUpdate
}

export const dreComparative = (state) => {
  return state.dreComparative.data || []
}
export const dreComparativeLoading = (state) => {
  return state.dreComparative.loading
}
export const dreComparativeLastUpdate = (state) => {
  return state.dreComparative.lastUpdate
}

export const dfcComparative = (state) => {
  return state.dfcComparative.data || []
}
export const dfcComparativeLoading = (state) => {
  return state.dfcComparative.loading
}
export const dfcComparativeLastUpdate = (state) => {
  return state.dfcComparative.lastUpdate
}

